/* eslint-disable radix */
import React, { Component } from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";

import EditorMessage from "../../infra/components/EditorMessage";
import PreviewMessage from "../../infra/components/PreviewMessage";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import CheckBoxInputField from "../../infra/components/formInput/CustomCheckBoxInput";

import ActionAdd from "../../store/action/HsmTemplate/Add";
import ActionEdit from "../../store/action/HsmTemplate/Edit";
import ActionGetDivisionAll from "../../store/action/Division/FetchAll";
import ActionGetSenderAll from "../../store/action/Sender/FetchAll";
import { IsEdit, IsCreate, IsView } from "../../store/constants";
import { ListMediaTypeHSM, ListTemplateType } from "../../store/local/list";
import ActionGetLanguageTemplate from "../../store/action/RegisterTemplate/FetchLanguage";
import {
    specialCharRegExp,
    URLFormat,
    PhoneNoFormat,
} from "../../infra/constants/regex";

import ButtonManager from "./ButtonManager";
import CardCarouselInput from "./CardCarouselInput";
import CardCarouselPreview from "./CardCarouselPreview";
import "./Styles.css";

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: fromJS({
                "template-id": "",
                namespace: "",
                "template-name": "",
                "client-id": "",
                "division-id": "",
                "sender-id": "",
                "template-category-id": "",
                type: "",
                "media-type": "",
                "param-size": 0,
                "raw-message": "",
                "priority-id": "",
                "lang-code": "",
                header: "",
                "header-param": 0,
                "raw-message-footer": "",
                "template-buttons": [],
                'template-type': '',
                'limited-offer-text': '',
                'offer-has-expiration': false,
                'template-carousels': [
                    {
                        "raw-message": "",
                        "format": "", // image / video
                        "param-size": 0,
                        "template-buttons": [
                            {
                                'button-type': '',
                                'button-message': '',
                                'button-value': '',
                                'value-type': '',
                            }
                        ],
                    }
                ],
            }),
            limitedOfferTextLength: 16,
            editorHtml: "",
            editorHtmlCarousels: [""],
            showMediaType: false,
            loadded: false,
            disabled: false,
            errors: fromJS({}),
            error: "",
            clientId: "",
            templateTypeUtility: fromJS([
                {
                    'value': '',
                    'name': 'General'
                },
                {
                    'value': 'carousel',
                    'name': 'Carousel'
                },
            ]),
            templateTypeMarketing: fromJS([
                {
                    'value': '',
                    'name': 'General'
                },
                {
                    'value': 'lto',
                    'name': 'LTO'
                },
                {
                    'value': 'coupon',
                    'name': 'Coupon'
                },
                {
                    'value': 'carousel',
                    'name': 'Carousel'
                },
                {
                    'value': 'catalog',
                    'name': 'Catalog'
                },
                {
                    'value': 'mpm',
                    'name': 'MPM'
                },
                {
                    'value': 'flow',
                    'name': 'Flow'
                },
            ]),
        };

        this.handleChange = this.handleChange.bind(this);
        this.addParamHeader = this.addParamHeader.bind(this);
        this.onChangeHeader = this.onChangeHeader.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.renderMediaType = this.renderMediaType.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
        this.setParamSize = this.setParamSize.bind(this);
        this.setEditorHtml = this.setEditorHtml.bind(this);
        this.onEditorCardCarouselChange = this.onEditorCardCarouselChange.bind(this);
        this.setParamSizeCardCarousel = this.setParamSizeCardCarousel.bind(this);
        this.handleChangeInCardCarousel = this.handleChangeInCardCarousel.bind(this);
        this.addMoreCardCarousel = this.addMoreCardCarousel.bind(this);
        this.deleteCardCarousel = this.deleteCardCarousel.bind(this);
    }

    addMoreCardCarousel() {
        const { form, editorHtmlCarousels } = this.state;
        let formVal = form;
        let carousels = form.get("template-carousels");
        let firstCarousel = form.get("template-carousels").get(0);
        let newCarousel = firstCarousel.set("raw-message", "")
        newCarousel = newCarousel.set("raw-message", "")
        newCarousel = newCarousel.set("param-size", 0)
        formVal = formVal.set("template-carousels", fromJS([...carousels, newCarousel]));
        this.setState({ form: formVal, editorHtmlCarousels: [...editorHtmlCarousels, ""] });
    }

    deleteCardCarousel(index) {
        const { form, editorHtmlCarousels } = this.state;
        let valueHtmls = editorHtmlCarousels;
        let formVal = form;
        let carousels = form.get("template-carousels").delete(index);
        formVal = formVal.set("template-carousels", carousels);
        valueHtmls.splice(index, 1);
        this.setState({ form: formVal, editorHtmlCarousels: valueHtmls });
    }

    onEditorChange(value, content) {
        let formVal = this.state.form;
        formVal = formVal.set("raw-message", value);
        if (content) {
            this.setState({ form: formVal, editorHtml: content });
        } else {
            this.setState({ form: formVal });
        }
    }

    onEditorCardCarouselChange(value, content, index) {
        const { form, editorHtmlCarousels } = this.state;
        let editorHtmlCarouselsUpdate = editorHtmlCarousels;
        let formVal = form;
        let carousels = form.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, "raw-message"], value)
        formVal = formVal.set("template-carousels", carouselsUpdate);

        if (content) {
            editorHtmlCarouselsUpdate[index] = content;
            this.setState({ form: formVal, editorHtmlCarousels: editorHtmlCarouselsUpdate });
        } else {
            this.setState({ form: formVal });
        }
    }

    setParamSize(paramSize, value) {
        let formVal = this.state.form;
        formVal = formVal.set("param-size", paramSize);
        if (value) formVal = formVal.set("raw-message", value);
        this.setState({ form: formVal });
    }

    setParamSizeCardCarousel(paramSize, value, index) {
        let formVal = this.state.form;;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate;
        if (value) {
            carouselsUpdate = carousels.mergeIn([index], {"param-size": paramSize, "raw-message": value })
        } else {
            carouselsUpdate = carousels.setIn([index, "param-size"], paramSize)
        }
        formVal = formVal.set("template-carousels", carouselsUpdate);
        this.setState({ form: formVal });
    }

    handleChangeInCardCarousel(field, value, index) {
        let formVal = this.state.form;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, field], value)
        formVal = formVal.set("template-carousels", carouselsUpdate);

        this.setState({ form: formVal }); 
    }

    handleChange(field, value) {
        let formVal = this.state.form;
        formVal = formVal.set(field, value);

        if (field === "template-type" && value === "carousel") {
            formVal = formVal.set("type", "text");
            formVal = formVal.set("media-type", "");
            this.setState({
                showMediaType: false,
            });
        }

        if (field === "template-category-id") {
            formVal = formVal.set("template-type", "");
        }

        if (field === "type" && value !== "media") {
            formVal = formVal.set("media-type", "");
            this.setState({
                showMediaType: false,
            });
        }

        if (field === "type" && value === "media") {
            if (formVal.get("template-type") === "carousel") {
                formVal = formVal.set("template-type", "");
            }
            this.setState({
                showMediaType: true,
            });
        }

        if (field === "client-id") {
            this.props.actionGetDivisionAll(value);
            this.props.actionGetSenderAll(value);
            this.state.clientId = value;
        }

        if (field === "division-id") {
            this.props.actionGetSenderAll(this.state.clientId, value);
        }

        if (field === "template-type" && value === 'carousel') {
            if (formVal.get('template-carousels') === undefined || formVal.get('template-carousels').size === 0) {
                const cardCarousel = [
                    {
                        "raw-message": "",
                        "format": "", // image / video
                        "param-size": 0,
                        "template-buttons": [
                            {
                                'button-type': '',
                                'button-message': '',
                                'button-value': '',
                                'value-type': '',
                            }
                        ],
                    }
                ]
                formVal = formVal.set("template-carousels", fromJS(cardCarousel));
            }
        }

        this.setState({ form: formVal });
    }
    async handleSubmit() {
        switch (this.props.actionType) {
            case IsCreate:
                await this.SubmitNewData();
                break;
            case IsEdit:
                await this.SubmitEditData();
                break;
            default:
            // code block
        }
    }

    validateForm(form) {
        let isValid = true;
        let listError = []

        if (!form.get("template-id") || form.get("template-id").replace(/\s/g, "").length === 0) {
            listError.push("Template ID must be filled")
        }

        if (
            !form.get("namespace") ||
            form.get("namespace").replace(/\s/g, "").length === 0
        ) {
            listError.push("Namespace must be filled")
        }

        if (!form.get("waba-id") || form.get("waba-id").replace(/\s/g, "").length === 0) {
            listError.push("WABA ID must be filled")
        }

        if (
            !form.get("template-name") ||
            form.get("template-name").replace(/\s/g, "").length === 0
        ) {
            listError.push("Template name must be filled with minimum 3 characters")
        } else {
            const anySpecialChar = specialCharRegExp.test(
                form.get("template-name")[0]
            );
            if (anySpecialChar || form.get("template-name")[0] === " ") {
                listError.push("Any special character not allowed on the first character of Template name")
            }
            if (form.get("template-name").length < 3) {
                listError.push("Template name must be filled with minimum 3 characters")
            }
        }

        if (!form.get("client-id")) {
            listError.push("Client must be filled")
        }
        if (!form.get("template-category-id")) {
            listError.push("Template category must be filled")
        }
        if (!form.get("priority-id")) {
            listError.push("Priority template must be filled")
        }
        if (!form.get("lang-code")) {
            listError.push("Language must be filled")
        }
        if (!form.get("type")) {
            listError.push("Type must be filled")
        }
        if (
            (!form.get("media-type") || form.get("media-type") === "text") &&
            form.get("type") === "media"
        ) {
            listError.push("Media type must be filled")
        }

        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }

        return isValid;
    }

    validateTemplateButtons(templateButtons) {
        const { form } = this.state;
        var isValid = true;
        let listError = []
        let hasCopyCode = false;
        let copyCodeIndex;
        let hasFlowid = false;
        let hasFlowScreen = false;

        // console.log(templateButtons,'templateButtons');
        

        templateButtons.forEach((button, index) => {
            if (button.get("button-message").length > 20) {
                listError.push("Button Message must be less than 20 characters")
            } else if (button.get("button-message").length === 0 || button.get("button-message").replace(/\s/g, "").length === 0) {
                listError.push("Button Message must be filled")
            }

            switch (button.get("button-type")) {
                case "URL":
                    if (button.get("button-value").length === 0 && form.get("template-category-id") !== 1)
                        listError.push("URL must be filled");
                    else if (!button.get("button-value").match(URLFormat) && form.get("template-category-id") !== 1)
                        listError.push("Invalid URL format, use 'protocol://address'")
                    break;
                case "PHONE_NUMBER":
                    if (button.get("button-value").length === 0)
                        listError.push("Phone Number must be filled")
                    else if (!button.get("button-value").match(PhoneNoFormat))
                        listError.push("Invalid phone number format")
                    break;
                case "quick_reply":
                    if (button.get("button-value").length > 25)
                        listError.push("Quick Reply Button Message must be less than 25 characters")
                    break;
                case "copy_code":
                    hasCopyCode = true;
                    copyCodeIndex = index;
                    break;
                case "flow":
                    if (button.get("flow-id").length !== 0) {
                        hasFlowid = true;
                    }
                    if (button.get("navigate-screen").length !== 0) {
                        hasFlowScreen = true;   
                    }
                    break;
                case "MPM":
                    break;
                case "CATALOG":
                    break;
                default:
                    listError.push("Invalid Button Type")
            }
        });

        if (form.get("template-type") === "coupon" && !hasCopyCode) {
            listError.push("Coupon template must have a copy code button")
        }

        if (form.get("template-type") === "lto" && hasCopyCode && copyCodeIndex !== 0) {
            listError.push("The copy code button should be first")
        }

        // console.log(hasFlowid,'hasFlowid');
        

        if (form.get("template-type") === "flow" && !hasFlowid) {
            listError.push("Flow template must have a Flow ID")
        }

        if (form.get("template-type") === "flow" && !hasFlowScreen) {
            listError.push("Flow template must have a Flow navigate screen")
        }

        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }

        return isValid;
    }

    validateCarousel(carousel) {
        let isValid = true;
        let listError = []
        let isButtonCardValid = true;
        let isFormatValid = true;
        let isMessageValid = true;
        let isAllCardHaveButton = true;
        let isAllCardHaveSameButton = true;

        const formatFirstCard = carousel.getIn([0, "format"]);
        const firstCardButton = carousel.getIn([0, "template-buttons"]);

        carousel.forEach((card) => {
            const isButtonValid = this.validateTemplateButtons(card.get("template-buttons"))
            if (!isButtonValid) {
                isButtonCardValid = false;
            }
            if (!card.get("template-buttons").size) {
                isAllCardHaveButton = false;
            }
            if (card.get("template-buttons").size !== firstCardButton.size) {
                isAllCardHaveSameButton = false;
            } else {
                for (let index = 0; index < card.get("template-buttons").size; index++) {
                    if (card.get("template-buttons").getIn([index, "button-type"]) !== firstCardButton.getIn([index, "button-type"])) {
                        isAllCardHaveSameButton = false;
                    }
                }
            }
            if (card.get("format") !== formatFirstCard || !card.get("format") || card.get("format") == "") {
                isFormatValid = false;
            }
            if (!card.get("raw-message").length) {
                isMessageValid = false;
            }
        })

        if (!isFormatValid) {
            listError.push("The card header format must have selected Image or Video and must be the same on all cards")
        }
        if (!isMessageValid) {
            listError.push("The card body message must be filled")
        }
        if (!isAllCardHaveButton) {
            listError.push("At least one button required for a card")
            isValid = false;
        }
        if (!isAllCardHaveSameButton) {
            listError.push("Each card must have the same number of buttons and the same button type")
            isValid = false;
        }
        if (!isButtonCardValid) {
            isValid = false;
        }
        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }

        return isValid;
    }

    async SubmitNewData() {
        const form = this.state.form;
        let isValidated = this.validateForm(form);
        const templateButtonValidated = this.validateTemplateButtons(
            form.get("template-buttons")
        );
        let header = form.get("header");
        let headerParam = form.get("header-param");

        if (form.get("type") === "media") {
            header = "";
            headerParam = 0;
        }

        var data = {
            data: {
                "template-id": form.get("template-id"),
                namespace: form.get("namespace"),
                "template-name": form.get("template-name"),
                "client-id": parseInt(form.get("client-id")),
                "division-id": parseInt(form.get("division-id")),
                "sender-id": form.get("sender-id"),
                "waba-id": form.get("waba-id"),
                "template-category-id": parseInt(form.get("template-category-id")),
                type: form.get("type"),
                "media-type": form.get("media-type"),
                "param-size":
                    form.get("param-size") === ""
                        ? 0
                        : parseInt(form.get("param-size")),
                "raw-message": form.get("raw-message"),
                "priority-id": form.get("priority-id"),
                "lang-code": form.get("lang-code"),
                header: header,
                "header-param": headerParam,
                "raw-message-footer": form.get("raw-message-footer"),
                "template-buttons": form.get("template-buttons").toJS(),
                "template-type": form.get("template-type"),
            },
        };

        if (form.get("template-type") === "lto") {
            data.data["raw-message-footer"] = "";
            data.data["limited-offer-text"] = form.get("limited-offer-text");
            data.data["offer-has-expiration"] = form.get("offer-has-expiration") ? 1 : 0;
        }

        if (form.get("template-type") === "carousel") {
            const isCarouselValid = this.validateCarousel(form.get("template-carousels"))
            if (!isCarouselValid) {
                isValidated = false;
            }
            data.data["template-carousels"] = form.get("template-carousels").toJS();
            data.data.header = "";
            data.data["header-param"] = 0;
            data.data["raw-message-footer"] = "";
        }

        // console.log("payload = ", data)

        if (isValidated && templateButtonValidated) {
            var response = await this.props.actionAdd(data);
            if (response.ok) {
                toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error("Save Failed", toast.POSITION.TOP_RIGHT);
            }
        }
    }

    async SubmitEditData() {
        const form = this.state.form;
        let isValidated = this.validateForm(form);
        const templateButtonValidated = this.validateTemplateButtons(
            form.get("template-buttons")
        );
        let header = form.get("header");
        let headerParam = form.get("header-param");

        if (form.get("type") === "media") {
            header = "";
            headerParam = 0;
        }

        var data = {
            data: {
                "template-id": form.get("template-id"),
                namespace: form.get("namespace"),
                "template-name": form.get("template-name"),
                "client-id": parseInt(form.get("client-id")),
                "division-id": parseInt(form.get("division-id")),
                "sender-id": form.get("sender-id"),
                "waba-id": form.get("waba-id"),
                "template-category-id": parseInt(form.get("template-category-id")),
                type: form.get("type"),
                "media-type": form.get("media-type"),
                "param-size": parseInt(form.get("param-size")),
                "raw-message": form.get("raw-message"),
                "priority-id": form.get("priority-id"),
                "lang-code": form.get("lang-code"),
                header: header,
                "header-param": headerParam,
                "raw-message-footer": form.get("raw-message-footer"),
                "template-buttons": form.get("template-buttons").toJS(),
                "template-type": form.get("template-type"),
            },
        };

        if (form.get("template-type") === "lto") {
            data.data["raw-message-footer"] = "";
            data.data["limited-offer-text"] = form.get("limited-offer-text");
            data.data["offer-has-expiration"] = form.get("offer-has-expiration") ? 1 : 0;
        }

        if (form.get("template-type") === "carousel") {
            const isCarouselValid = this.validateCarousel(form.get("template-carousels"))
            if (!isCarouselValid) {
                isValidated = false;
            }
            data.data["template-carousels"] = form.get("template-carousels").toJS();
            data.data.header = "";
            data.data["header-param"] = 0;
            data.data["raw-message-footer"] = "";
        }

        if (isValidated && templateButtonValidated) {
            var response = await this.props.actionEdit(data);
            if (response.ok) {
                toast.success("Edit Success!", toast.POSITION.TOP_RIGHT);
                this.props.handleCancelForm(true);
            } else {
                toast.error("Edit Failed", toast.POSITION.TOP_RIGHT);
            }
        }
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    addParamHeader() {
        const { form } = this.state;
        let formVal = form;
        let textBody = form.get("header");
        textBody = `${textBody} {{1}}`;
        formVal = formVal.set("header", textBody);
        formVal = formVal.set("header-param", 1);
        this.setState({ form: formVal });
    }

    onChangeHeader(field, value) {
        let formVal = this.state.form;
        let cekparamheader = "";
        let ind = 0;
        let tempstr = "";
        let flag = 0;
        let paramarr = [];
        const regex = /[^0-9]/g;
        for (let i = 0; i < value.length; i++) {
            if (value[i] == "{" && value[i + 1] == "{") {
                ind = value.indexOf("}", i);
                if (ind < 0) {
                    continue;
                } else if (value[ind + 1] == "}") {
                    tempstr = value.substring(i + 2, ind);
                    if (tempstr.match(regex) == null) {
                        cekparamheader = value.substring(i, ind + 2);
                        if (parseInt(tempstr) > 1 || parseInt(tempstr) < 1) {
                            value = value.replace(cekparamheader, "");
                            break;
                        }
                        if (tempstr == paramarr[0]) {
                            value = value.replace(cekparamheader, "");
                            break;
                        }
                        if (flag == 0) {
                            paramarr.push(tempstr);
                            flag += 1;
                            formVal = formVal.set("header-param", 1);
                            this.setState({
                                form: formVal,
                            });
                        } else {
                            continue;
                        }
                    }
                }
            } else {
                if (flag === 1) {
                    continue;
                } else {
                    formVal = formVal.set("header-param", 0);
                    this.setState({
                        form: formVal,
                    });
                }
            }
        }

        formVal = formVal.set(field, value);
        this.setState({ form: formVal });
    }

    setEditorHtml(value) {
        let editorValue = "";
        let rawValue = "";
    
        if (!value || !value.length) {
            return { editorValue, rawValue };
        }
    
        const lines = value.split("\n");
    
        if (lines.length === 1) {
            editorValue = "<p>" + lines[0] + "</p>";
            rawValue = lines[0];
        } else {
            editorValue = lines
                .map((line, index) => {
                    if (line.trim() === "") {
                        return "<p><br></p>";
                    } else {
                        return index === lines.length - 1
                            ? "<p>" + line + "</p>"
                            : "<p>" + line + "</p><p>";
                    }
                })
                .join("");
            rawValue = lines.join("\n");
        }
    
        rawValue = rawValue.replace(/<\/p><p>/g, "\n");
        rawValue = rawValue.replace(/<p>|<\/p>/g, "");
    
        if (rawValue === "\n") {
            rawValue = "";
        }
    
        return { editorValue, rawValue };
    }

    componentWillMount() {
        const { item, actionType } = this.props;
        if (item != null || item !== undefined) {
            if (
                (actionType === IsView || actionType === IsEdit) &&
                !this.state.loadded
            ) {
                if (item.get("division-id")) {
                    this.props.actionGetSenderAll(item.get("client-id"), item.get("division-id"));
                } else {
                    this.props.actionGetSenderAll(item.get("client-id"));
                }

                this.props.actionGetDivisionAll(item.get("client-id"));
                this.state.clientId = item.get("client-id")

                const { editorValue, rawValue } = this.setEditorHtml(
                    item.get("raw-message")
                );

                var mediaType = item.get("media-type") ? item.get("media-type").toLowerCase() : "";

                console.log(item,'items');

                var buttonCarousel = item.get("template-carousels");
                var templateCarousels = [];
                if (item.get("template-type")==="carousel") {
                    buttonCarousel.map((item, index) => {
                        templateCarousels.push({
                            "raw-message": item.get("raw-message"),
                            "format": item.get("format"),
                            "param-size": item.get("param-size"),
                            "template-buttons": item.get("template-buttons"),
                        });
                    });
                }
                

                var f = fromJS({
                    "template-id": item.get("template-id"),
                    namespace: item.get("namespace"),
                    "template-name": item.get("template-name"),
                    "client-id": item.get("client-id"),
                    "division-id": item.get("division-id"),
                    "sender-id": item.get("sender-id"),
                    "waba-id": item.get("waba-id"),
                    "template-category-id": item.get("template-category-id"),
                    type: item.get("type"),
                    "media-type": mediaType,
                    "param-size": item.get("param-size"),
                    "raw-message": rawValue,
                    "priority-id": item.get("priority-id"),
                    "lang-code": item.get("lang-code"),
                    header: item.get("header") || "",
                    "header-param": item.get("header-param") || 0,
                    "raw-message-footer": item.get("raw-message-footer") || "",
                    "template-buttons": item.get("template-buttons"),
                    "limited-offer-text": item.get("limited-offer-text"),
                    "template-type": item.get("template-type"),
                    "offer-has-expiration": item.get("offer-has-expiration") === 1 ? true : false,
                    "template-carousels": templateCarousels,
                });

                if (f.get("media-type") == "text") {
                    f = f.set("type", "text");
                } else {
                    f = f.set("type", "media");
                }

                this.setState({
                    form: f,
                    editorHtml: editorValue,
                    showMediaType: f.get("type") === "media" ? true : false,
                    loadded: true,
                    disabled: this.props.actionType === IsView,
                });
            }
        }
    }

    componentDidMount() {
        if (this.props.languageTemplate.equals(fromJS({}))) {
            this.props.actionGetLanguageTemplate();
        }
    }

    render() {
        const { form, errors, disabled, editorHtml, editorHtmlCarousels, limitedOfferTextLength } = this.state;
        var btnSubmit = (
            <button
                type="button"
                className="btn btn-wide btn-success"
                onClick={this.handleSubmit}
            >
                Submit
            </button>
        );

        if (disabled) {
            btnSubmit = "";
        }

        const detailLto = {
            id: {
                limitedOfferText: form.get('limited-offer-text'),
                offerHasExpiration: form.get('offer-has-expiration'),
                offerTimeExpiredText: 'Penawaran berakhir pada <EXPIRATION TIME>',
                codeText: 'Kode <OFFER_CODE>',
            },
            en: {
                limitedOfferText: form.get('limited-offer-text'),
                offerHasExpiration: form.get('offer-has-expiration'),
                offerTimeExpiredText: 'Offer ends on <EXPIRATION TIME>',
                codeText: 'Code <OFFER_CODE>',
            }
        }
        const ltoPreview = form.get("lang-code") === 'id' ? detailLto.id : detailLto.en;

        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">ID</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={"template-id"}
                                value={form.get("template-id")}
                                onChange={(field, value) =>
                                    this.handleChange(field, value)
                                }
                                placeholder="template id"
                                disabled={this.props.actionType === IsView || this.props.actionType === IsEdit}
                                hasError={errors.has("template-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Name</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={"template-name"}
                                value={form.get("template-name")}
                                onChange={(field, value) =>
                                    this.handleChange(field, value)
                                }
                                placeholder="template name"
                                disabled={disabled}
                                hasError={errors.has("template-name")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="client-id"
                                value={form.get("client-id")}
                                options={fromJS({
                                    source: this.props.clientall,
                                    value: "client-id",
                                    label: "client-name",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Client"
                                disabled={disabled}
                                hasError={errors.has("client-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2">Division</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="division-id"
                                value={form.get("division-id")}
                                options={fromJS({
                                    source: this.props.divisionall,
                                    value: "division-id",
                                    label: "division-name",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Division"
                                disabled={disabled}
                                hasError={errors.has("division-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="sender-id"
                                value={form.get("sender-id")}
                                options={fromJS({
                                    source: this.props.senderall,
                                    value: "sender-id",
                                    label: "sender-name",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Sender"
                                disabled={disabled}
                                hasError={errors.has("sender-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Category</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="template-category-id"
                                value={form.get("template-category-id")}
                                options={fromJS({
                                    source: this.props.listTemplateCategory,
                                    value: "template-category-id",
                                    label: "template-category-name",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Template Category"
                                disabled={disabled}
                                hasError={errors.has("template-category-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Namespace</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={"namespace"}
                                value={form.get("namespace")}
                                onChange={(field, value) =>
                                    this.handleChange(field, value)
                                }
                                placeholder="namespace"
                                disabled={disabled}
                                hasError={errors.has("namespace")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">WABA ID</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={"waba-id"}
                                value={form.get("waba-id")}
                                onChange={(field, value) =>
                                    this.handleChange(field, value)
                                }
                                placeholder="waba id"
                                disabled={disabled}
                                hasError={errors.has("waba-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Priority</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="priority-id"
                                value={form.get("priority-id")}
                                options={fromJS({
                                  source: [
                                    { idPrio: 4, namePrio: "Jalur Reguler" },
                                    { idPrio: 6, namePrio: "Notification" },
                                    { idPrio: 9, namePrio: "OTP" },
                                  ],
                                  value: "idPrio",
                                  label: "namePrio",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Priority Template"
                                disabled={disabled}
                                hasError={errors.has("priority-id")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Language</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="lang-code"
                                value={form.get("lang-code")}
                                options={fromJS({
                                    source: this.props.languageTemplate,
                                    value: "lang_code",
                                    label: "language",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Language"
                                disabled={disabled}
                                hasError={errors.has("lang-code")}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2 required">Type</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field="type"
                                value={form.get("type")}
                                options={fromJS({
                                    source: ListTemplateType(),
                                    value: "value",
                                    label: "label",
                                })}
                                onChange={(field, value, label) =>
                                    this.handleChange(field, value, label)
                                }
                                placeholder="Type"
                                disabled={disabled}
                                hasError={errors.has("type")}
                            />
                        </div>
                    </div>

                    {this.renderMediaType(form, errors)}

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2 pt-2">Param Size</span>
                        <div className="col-sm-3">
                            <TextInputField
                                className="form-control"
                                number
                                field={"param-size"}
                                value={form.get("param-size")}
                                onChange={(field, value) =>
                                    this.handleChange(field, value)
                                }
                                placeholder="Param Size"
                                disabled={true}
                                hasError={errors.has("param-size")}
                            />
                        </div>
                    </div>
                    {(form.get('template-category-id') === 2 || form.get('template-category-id') === 3) && (
                        <div className="row no-margin-bottom">
                            <span className="col-sm-2 pt-2">Template Type</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field='template-type'
                                    value={form.get('template-type')}
                                    options={fromJS({
                                        'source': form.get('template-category-id') === 2 ? this.state.templateTypeMarketing : this.state.templateTypeUtility,
                                        'value': 'value',
                                        'label': 'name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Template Type"
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div id="chat-container">
                    <div className="col-md-12 nopadding">
                        <div className="col-md-8  nopadding">
                            <div className="card noborder-left noborder-right card_noborderradius">
                                <div
                                    className="body msg_editor_body"
                                    ref={(el) => {
                                        this.messagesEnd = el;
                                    }}
                                >
                                    <div className="row no-margin-bottom col-sm-12">
                                        <p className="col-sm-12 font-weight-bold">
                                            Raw Message
                                        </p>
                                        {form.get("type") === "text" && form.get("template-type") !== "carousel" && (
                                            <React.Fragment>
                                                <p className="col-sm-12 mb-0">
                                                    <span className="font-weight-bold">
                                                        Header
                                                    </span>
                                                    {!disabled && (
                                                        <React.Fragment>
                                                            <br />
                                                            <span className="font-weight-light">
                                                                Add a short line
                                                                of text to the
                                                                header of your
                                                                message template
                                                            </span>
                                                        </React.Fragment>
                                                    )}
                                                </p>
                                                <div className="row header_msg">
                                                    <div className="row col-sm-10 ml-4">
                                                        <TextInputField
                                                            className="form-control pr-5"
                                                            field={"header"}
                                                            value={form.get(
                                                                "header"
                                                            )}
                                                            onChange={(
                                                                field,
                                                                value
                                                            ) =>
                                                                this.onChangeHeader(
                                                                    field,
                                                                    value
                                                                )
                                                            }
                                                            placeholder={
                                                                disabled
                                                                    ? ""
                                                                    : "Input header here..."
                                                            }
                                                            maxLength={60}
                                                            disabled={disabled}
                                                            hasError={errors.has(
                                                                "header"
                                                            )}
                                                        />
                                                        <span className="length-header">
                                                            {
                                                                form.get(
                                                                    "header"
                                                                ).length
                                                            }
                                                            /60
                                                        </span>
                                                    </div>
                                                    <div className="col-sm-1">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            onClick={
                                                                this
                                                                    .addParamHeader
                                                            }
                                                            disabled={
                                                                disabled ||
                                                                form.get(
                                                                    "header"
                                                                ).length > 54 ||
                                                                form.get(
                                                                    "header-param"
                                                                ) > 0
                                                            }
                                                        >
                                                            {"{{}}"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="row no-margin-bottom col-sm-12 ">
                                        <p className="col-sm-12 no-margin-bottom">
                                            <span className="font-weight-bold required">
                                                Body
                                            </span>
                                            {!disabled && (
                                                <React.Fragment>
                                                    <br />
                                                    <span className="font-weight-light">
                                                        Enter the text for your
                                                        message in the language
                                                        you've selected.
                                                    </span>
                                                    <Tooltip
                                                        title={
                                                            <React.Fragment>
                                                                <Typography
                                                                    variant="h6"
                                                                    color="inherit"
                                                                >
                                                                    Maximum 2
                                                                    times
                                                                    concecutively
                                                                    for spacing
                                                                    'ENTER'
                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <button>
                                                            <i className="small-icon">
                                                                <InfoIcon />
                                                            </i>
                                                        </button>
                                                    </Tooltip>
                                                </React.Fragment>
                                            )}
                                        </p>
                                        <div className={`col-sm-12 pt-2`}>
                                            <div>
                                                <EditorMessage
                                                    value={editorHtml}
                                                    lengthValue={
                                                        form.get("raw-message")
                                                            ? form.get(
                                                                  "raw-message"
                                                              ).length
                                                            : 0
                                                    }
                                                    onChange={
                                                        this.onEditorChange
                                                    }
                                                    setParamSize={
                                                        this.setParamSize
                                                    }
                                                    paramSize={form.get(
                                                        "param-size"
                                                    )}
                                                    disabled={disabled}
                                                    placeholder={
                                                        "Input message here..."
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {form.get("template-type") !== "lto" && form.get("template-type") !== "carousel" && (
                                        <div className="row no-margin-bottom col-sm-12">
                                            <p className="col-sm-12 mb-0">
                                                <span className="font-weight-bold">
                                                    Footer
                                                </span>
                                                {!disabled && (
                                                    <React.Fragment>
                                                        <br />
                                                        <span className="font-weight-light">
                                                            Add a short line of text
                                                            to the bottom of your
                                                            message template.
                                                        </span>
                                                    </React.Fragment>
                                                )}
                                            </p>
                                            <div className={`col-sm-12`}>
                                                <TextInputField
                                                    className="form-control pr-5"
                                                    field={"raw-message-footer"}
                                                    value={form.get(
                                                        "raw-message-footer"
                                                    )}
                                                    onChange={(field, value) =>
                                                        this.handleChange(
                                                            field,
                                                            value
                                                        )
                                                    }
                                                    maxLength={60}
                                                    placeholder={
                                                        disabled
                                                            ? ""
                                                            : "Input footer here..."
                                                    }
                                                    disabled={disabled}
                                                    hasError={errors.has(
                                                        "raw-message-footer"
                                                    )}
                                                />
                                                <span className="length-footer">
                                                    {
                                                        form.get(
                                                            "raw-message-footer"
                                                        ).length
                                                    }
                                                    /60
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {form.get("template-type") === "lto" && (
                                        <>
                                            <div className="row no-margin-bottom col-sm-12">
                                                <p className="col-sm-12 mb-0">
                                                    <span className="font-weight-bold">
                                                        Limited-time offer
                                                    </span>
                                                    {!disabled && (
                                                        <React.Fragment>
                                                            <br />
                                                            <span className="font-weight-light">
                                                                Add a short line of text
                                                                for detail promo.
                                                            </span>
                                                        </React.Fragment>
                                                    )}
                                                </p>
                                                <div className={`col-sm-12`}>
                                                    <TextInputField
                                                        className="form-control pr-5"
                                                        field={"limited-offer-text"}
                                                        value={form.get(
                                                            "limited-offer-text"
                                                        )}
                                                        onChange={(field, value) =>
                                                            this.handleChange(
                                                                field,
                                                                value
                                                            )
                                                        }
                                                        maxLength={limitedOfferTextLength}
                                                        placeholder={
                                                            disabled
                                                                ? ""
                                                                : "Input Limited-time offer text here..."
                                                        }
                                                        disabled={disabled}
                                                        hasError={errors.has(
                                                            "limited-offer-text"
                                                        )}
                                                    />
                                                    <span className="length-footer">
                                                        {
                                                            form.get(
                                                                "limited-offer-text"
                                                            ).length
                                                        }
                                                        /{limitedOfferTextLength}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <CheckBoxInputField className="form-control"
                                                    field={"offer-has-expiration"}
                                                    checked={form.get('offer-has-expiration')}
                                                    onChange={(field, value) => this.handleChange(field, value)}
                                                    label="Has expiration"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {form.get("template-type") !== "carousel" ? (
                                        <ButtonManager
                                            disabled={disabled}
                                            clientId={form.get("client-id")}
                                            categoryId={form.get("template-category-id")}
                                            templateType={form.get("template-type")}
                                            items={form.get("template-buttons")}
                                            onChange={(field, value) =>
                                                this.handleChange(field, value)
                                            }
                                            hasError={errors.has(
                                                "template-buttons"
                                            )}
                                        />
                                    ) : (
                                        <div className="input-carousel-wrapper">
                                            {form.get("template-carousels").map((card, index) => (
                                                <CardCarouselInput
                                                    key={`card-carousel-${index+1}`}
                                                    disabled={disabled}
                                                    editorHtmlCarousels={editorHtmlCarousels}
                                                    index={index}
                                                    errors={errors}
                                                    handleChange={this.handleChangeInCardCarousel}
                                                    onEditorChange={this.onEditorCardCarouselChange}
                                                    setParamSize={this.setParamSizeCardCarousel}
                                                    buttons={card.get("template-buttons")}
                                                    paramSize={card.get("param-size")}
                                                    rawMessage={card.get("raw-message")}
                                                    format={card.get("format")}
                                                    categoryId={form.get("template-category-id")}
                                                    onRemove={form.get("template-carousels").size > 1 && this.deleteCardCarousel}
                                                    onAddMoreCard={form.get("template-carousels").size === index+1 && form.get("template-carousels").size < 10 ? this.addMoreCardCarousel : null}
                                                />
                                            ))}
                                        </div>
                                    )}
                                    <div className="row no-margin-bottom pl-4">
                                        <div className="col-sm-12 pt-4">
                                            <button
                                                type="button"
                                                className="btn btn-wide btn-danger"
                                                value="Cancel"
                                                onClick={this.handleCancel}
                                            >
                                                Cancel
                                            </button>
                                            {btnSubmit}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 nopadding">
                            <PreviewMessage
                                rawMessage={form.get("raw-message")}
                                textHeader={form.get("header")}
                                textFooter={form.get("raw-message-footer")}
                                type={form.get("type")}
                                mediaType={form.get("media-type")}
                                buttons={form.get('template-buttons')}
                                cardCarousel={form.get("template-type") === 'carousel'
                                                && <CardCarouselPreview templateCarousels={form.get("template-carousels")} />}
                                lto={form.get("template-type") === 'lto' && ltoPreview }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMediaType(form, errors) {
        if (this.state.showMediaType) {
            return (
                <div className="row no-margin-bottom">
                    <span className="col-sm-2 pt-2 required">Media Type</span>
                    <div className="col-sm-10">
                        <ComboboxInput
                            field="media-type"
                            value={form.get("media-type")}
                            options={fromJS({
                                source: ListMediaTypeHSM(),
                                value: "value",
                                label: "label",
                            })}
                            onChange={(field, value, label) =>
                                this.handleChange(field, value, label)
                            }
                            placeholder="Media Type"
                            disabled={this.state.disabled}
                            hasError={errors.has("media-type")}
                        />
                    </div>
                </div>
            );
        }
    }
}

export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            languageTemplate: state.user.languageTemplate,
            listPriorityTemplate: state.user.listPriorityTemplate,
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                actionAdd: ActionAdd,
                actionEdit: ActionEdit,
                actionGetDivisionAll: ActionGetDivisionAll,
                actionGetSenderAll: ActionGetSenderAll,
                actionGetLanguageTemplate: ActionGetLanguageTemplate,
            },
            dispatch
        )
)(Form);
